import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { convertDepartmentsIntoTableRows } from '../../utils/department/Department.utils';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const DepartmentOverview: React.FC = () => {
  const { axios, updateContextUser, user } = useUser();
  const { data: loadedDepartments } = useData('DEPARTMENT_ALL', {
    config: { fallbackData: [] },
  });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const rows: TableRow[] = useMemo(
    (): TableRow[] => convertDepartmentsIntoTableRows(loadedDepartments, navigate),
    [loadedDepartments, navigate],
  );

  return (
    <>
      <TopBar title={t('pages.department.overview.topBarHeadline')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/department/edit')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.DEPARTMENT_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.DEPARTMENT_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={rows}
          header={
            t('pages.department.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
